import type { ICardData } from '@moko/utils';
import { FieldIcon, formatEntryText } from './cardRendering';

interface SlotSummaryProps {
  data: ICardData;
  fallbackText?: string;
}

const SlotSummary = ({ data, fallbackText }: SlotSummaryProps) => {
  if (data.slots.length === 0 && fallbackText) {
    return <span>{fallbackText}</span>;
  }

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}
    >
      {data.slots.map((slot) => {
        const isInline = slot.display === 'inline';
        const style: React.CSSProperties = {
          fontSize: slot.fontSize,
          fontWeight: slot.fontWeight,
          color: slot.color ?? undefined,
        };

        const entries = slot.entries.map((entry, i) => (
          <span
            key={entry.key}
            style={{ display: 'inline-flex', alignItems: 'flex-start', gap: 3 }}
          >
            <FieldIcon icon={entry.icon} fontSize={slot.fontSize} />
            <span>{formatEntryText(entry)}</span>
            {isInline && i < slot.entries.length - 1 && (
              <span style={{ opacity: 0.5, margin: '0 2px' }}>|</span>
            )}
          </span>
        ));

        return (
          <div key={slot.slotId} style={style}>
            {entries}
          </div>
        );
      })}
    </div>
  );
};

export default SlotSummary;
